/**
 * Холст черепахи рядом с редактором кода (workspace_kind=code_turtle).
 * Рисует след по командам из Pyodide (postMessage / CustomEvent diobuch-turtle).
 */
import { useEffect, useRef } from 'react';

const DEFAULT_SIZE = 360;

export default function TurtleCanvas({ height = DEFAULT_SIZE }) {
  const canvasRef = useRef(null);
  const stateRef = useRef({
    x: 0,
    y: 0,
    angle: 0,
    penDown: true,
    color: '#7dd3fc',
  });

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const w = canvas.clientWidth || DEFAULT_SIZE;
    const h = height;
    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.fillStyle = '#0f1419';
    ctx.fillRect(0, 0, w, h);
    stateRef.current = {
      x: w / 2,
      y: h / 2,
      angle: -90,
      penDown: true,
      color: '#7dd3fc',
    };

    function clear() {
      ctx.fillStyle = '#0f1419';
      ctx.fillRect(0, 0, w, h);
      stateRef.current.x = w / 2;
      stateRef.current.y = h / 2;
      stateRef.current.angle = -90;
    }

    function drawTo(nx, ny) {
      const s = stateRef.current;
      if (s.penDown) {
        ctx.beginPath();
        ctx.strokeStyle = s.color;
        ctx.lineWidth = 2;
        ctx.moveTo(s.x, s.y);
        ctx.lineTo(nx, ny);
        ctx.stroke();
      }
      s.x = nx;
      s.y = ny;
    }

    function handleCommand(cmd) {
      if (!cmd || typeof cmd !== 'object') return;
      const s = stateRef.current;
      const type = String(cmd.type || '').toLowerCase();
      if (type === 'clear' || type === 'reset') {
        clear();
        return;
      }
      if (type === 'pendown') {
        s.penDown = true;
        return;
      }
      if (type === 'penup') {
        s.penDown = false;
        return;
      }
      if (type === 'color' && cmd.color) {
        s.color = String(cmd.color);
        return;
      }
      if (type === 'setheading' && Number.isFinite(Number(cmd.angle))) {
        s.angle = Number(cmd.angle);
        return;
      }
      if (type === 'goto') {
        const nx = Number(cmd.x);
        const ny = Number(cmd.y);
        if (Number.isFinite(nx) && Number.isFinite(ny)) drawTo(nx, ny);
        return;
      }
      if (type === 'forward') {
        const dist = Number(cmd.distance) || 0;
        const rad = (s.angle * Math.PI) / 180;
        drawTo(s.x + Math.cos(rad) * dist, s.y + Math.sin(rad) * dist);
        return;
      }
      if (type === 'left') {
        s.angle -= Number(cmd.angle) || 0;
        return;
      }
      if (type === 'right') {
        s.angle += Number(cmd.angle) || 0;
      }
    }

    function onEvent(ev) {
      const detail = ev?.detail;
      if (Array.isArray(detail)) detail.forEach(handleCommand);
      else handleCommand(detail);
    }

    window.addEventListener('diobuch-turtle', onEvent);
    return () => window.removeEventListener('diobuch-turtle', onEvent);
  }, [height]);

  function handleClear() {
    window.dispatchEvent(new CustomEvent('diobuch-turtle', { detail: { type: 'clear' } }));
  }

  return (
    <div className="turtle-canvas-wrap">
      <div className="turtle-canvas-toolbar">
        <span>Холст черепахи</span>
        <button type="button" className="btn btn-outline btn-xs" onClick={handleClear}>
          Очистить
        </button>
      </div>
      <canvas ref={canvasRef} className="turtle-canvas" style={{ height }} />
      <p className="turtle-canvas-hint">
        Из Python: <code>import diobuch_turtle as t</code> затем <code>t.forward(50)</code>, <code>t.left(90)</code>.
      </p>
    </div>
  );
}
